import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';

import api from './../../service/api';
import { formatCurrency, formatDate } from '../../service/format';
import { downloadCsv } from '../../service/handle';
import { Divider } from 'primereact/divider';
import CreateExpense from './create';
import UpdateExpense from './update';
import DeleteExpense from './delete';

const Expense = () => {
    let emptyExpense = {
        description: '',
        truck: null,
        due_date: '',
        purchase_date: '',
        amount: null
    };
    
    const [expenses, setExpenses] = useState([]);
    const [paymentDate, setPaymentDate] = useState((new Date()).getTime());
    const [dueDate, setDueDate] = useState((new Date()).getTime());
    const [expenseDialog, setExpenseDialog] = useState(false);
    const [expense, setExpense] = useState(emptyExpense);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteExpenseDialog, setDeleteExpenseDialog] = useState(false);
    const [payExpenseDialog, setPayExpenseDialog] = useState(false);

    const [totalExpense, setTotalExpense] = useState(0);
    const [totalExpensePay, setTotalExpensePay] = useState(0);
    const [totalExpensePending, setTotalExpensePending] = useState(0);

    const [updateExpenseDialog, setUpdateExpenseDialog] = useState(false);
    const [updateExpenseCode, setUpdateExpenseCode] = useState(false);

    const toast = useRef(null);
    const dt = useRef(null);
    
    const statusTranslated = {
        'pending': <Tag severity='info'>Pendente</Tag>,
        'overdue': <Tag severity='danger'>Vencida</Tag>,
        'done': <Tag severity='success'>Paga</Tag>
    };

    const hidePayExpenseDialog = () => {
        setPayExpenseDialog(false);
    }

    const confirmPayExpense = (expense) => {
        setPaymentDate((new Date()));
        setExpense({ ...expense });
        setPayExpenseDialog(true);
    }

    const openNew = () => {
        setExpense(emptyExpense);
        setSubmitted(false);
        setExpenseDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setExpenseDialog(false);
        setDisabled(false);
    }

    

    const handlePayExpense = () => {
        if(!paymentDate) return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);

        api().post('/expense/pay', { code: expense.code, payment_date: paymentDate.getTime() }).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listExpenses();
                hidePayExpenseDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const listExpenses = (_dueDate = false) => {
        var _dueDate = new Date(_dueDate || dueDate);

        _dueDate.setDate(1);
        _dueDate.setHours(0);
        _dueDate.setMinutes(0);
        _dueDate.setSeconds(0);
        _dueDate.setMilliseconds(0);

        setLoading(true);
        api().post('/expense/list/byduedate', { due_date: _dueDate.getTime() }).then(response => {
            if(response.status === 200 && response.data.result){
                var amountExpense = 0;
                var amountExpensePay = 0;
                var amountExpensePending = 0;

                setExpenses(response.data.data.map(data => {
                    amountExpense += data.amount;

                    var status = 'pending';
                    if(data['payment_date']) {
                        status = 'done';
                        amountExpensePay += data.amount
                    } else if(data['due_date'] && data['due_date'] < (new Date()).getTime()) status = 'overdue';

                    data['status'] = status;
                    data['plate'] = (data['plate'] || '').toUpperCase();

                    if(status !== 'done') amountExpensePending += data.amount;

                    return data;
                }));
                
                setTotalExpense(amountExpense);
                setTotalExpensePay(amountExpensePay);
                setTotalExpensePending(amountExpensePending);
            }
            setLoading(false);
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="field col-12 md:col-6">
                    <label htmlFor="monthpicker">Mês</label>
                    <Calendar locale='pt-br' showIcon id="monthpicker" value={new Date(dueDate)} onChange={(e) => {
                        setDueDate((new Date(e.value)).getTime());
                        listExpenses((new Date(e.value)).getTime());
                    }} view="month" dateFormat="mm/yy" yearNavigator yearRange={`2020:${(new Date()).getFullYear() + 5}`} />
                </div>
            </React.Fragment>
        )
    }

    const [loadingExport, setLoadingExport] = useState(false);

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova " icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    <Button label="Exportar" icon="pi pi-download" loading={loadingExport} className="p-button-text" onClick={() => {
                        setLoadingExport(true);
                        downloadCsv(['Descrição', 'Caminhão', 'Fornecedor', 'Categoria', 
                    'Valor', 'Data Lançamento', 'Data Compra', 'Data Vencimento', 'Data Pagamento'], expenses.map(data => {
                            var dateOptions = {
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric'
                            }
                            return [
                                data.description,
                                (data.plate || '-').toUpperCase(),
                                data.suppliername,
                                data.categorydescription,
                                formatCurrency(data.amount),
                                data.createdat ? new Date(data.createdat).toLocaleDateString('pt-br', dateOptions) : '-',
                                data.purchase_date ? new Date(data.purchase_date).toLocaleDateString('pt-br', dateOptions) : '-',
                                data.due_date ? new Date(data.due_date).toLocaleDateString('pt-br', dateOptions) : '-',
                                data.payment_date ? new Date(data.payment_date).toLocaleDateString('pt-br', dateOptions) : '-',
                            ];
                        }), 'Despesa_' + Date.now());
                        setTimeout(() => {
                            setLoadingExport(false)
                        }, 3000);
                    }} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Despesas</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    

    const payExpenseDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hidePayExpenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handlePayExpense} />
        </>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                { !rowData.payment_date ? (
                    <Button label='Pagar' className="p-button-rounded p-button-success mr-2" onClick={() => confirmPayExpense(rowData)} />
                )  : ''}
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => {
                    setUpdateExpenseCode(rowData.code || false);
                    setDeleteExpenseDialog(true); 
                }} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    setUpdateExpenseCode(rowData.code || false);
                    setUpdateExpenseDialog(true); 
                }} />
            </div>
        );
    }
   
    useEffect(() => {
        listExpenses();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Despesas</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(totalExpense, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-yellow-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-yellow-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Pago</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(totalExpensePay, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-green-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-green-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Pendente</span>
                            <div className="text-900 font-medium text-xl">{formatCurrency(totalExpensePending, true)}</div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-money-bill text-orange-500 text-xl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" right={rightToolbarTemplate} left={leftToolbarTemplate}></Toolbar>


                    <CreateExpense visible={expenseDialog} onCreate={() => {
                        listExpenses();
                        setExpenseDialog(false);
                    }} handleCancel={() => {
                        setExpenseDialog(false);
                    }} />
                    <UpdateExpense code={updateExpenseCode} visible={updateExpenseDialog} onUpdate={() => {
                        listExpenses();
                        setUpdateExpenseDialog(false);
                    }} handleCancel={() => {
                        setUpdateExpenseDialog(false);
                    }} />
                    <DeleteExpense code={updateExpenseCode} visible={deleteExpenseDialog} onDelete={() => {
                        listExpenses();
                        setDeleteExpenseDialog(false);
                    }} handleCancel={() => {
                        setDeleteExpenseDialog(false);
                    }} />

                    <DataTable ref={dt} value={expenses} loading={loading}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="description" header="Descrição"></Column>
                        <Column field="plate" header="Caminhão"></Column>
                        <Column field="suppliername" header="Fornecedor" style={{whiteSpace: 'nowrap'}}></Column>
                        <Column field="categorydescription" header="Categoria"></Column>
                        <Column field="due_date" header="Vencimento" body={rowData => rowData.due_date ? formatDate(rowData.due_date, false) : '-'}></Column>
                        <Column field="purchase_date" header="Compra" body={rowData => rowData.purchase_date ? formatDate(rowData.purchase_date, false) : '-'}></Column>
                        <Column field="payment_date" header="Pagamento" body={rowData => rowData.payment_date ? formatDate(rowData.payment_date, false) : '-'}></Column>
                        <Column field="amount" body={rowData => formatCurrency(rowData.amount || 0, true)} header="Valor (R$)"></Column>
                        <Column field="status" body={rowData => statusTranslated[rowData.status] || '-'} header="Situação"></Column>
                        <Column body={actionBodyTemplate} style={{width: '20%', whiteSpace: 'nowrap'}}></Column>
                    </DataTable>

                    <Dialog visible={payExpenseDialog} style={{ width: '450px' }} className="p-fluid" header="Confirmar pagamento" modal footer={payExpenseDialogFooter} onHide={hidePayExpenseDialog}>
                        <div className='formgrid grid'>
                            <div className="flex align-items-center justify-content-center">
                                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                                {expense && <span>Você tem certeza que deseja pagar esta despesa?</span>}
                            </div>
                        </div>
                        <Divider />
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="paymentDate">Data de Pagamento</label>
                                <Calendar id="paymentDate" dateFormat="dd/mm/yy" locale='pt-br' value={paymentDate ? paymentDate : (new Date())} onChange={(e) => setPaymentDate(e.value)} showIcon />
                                {submitted && !paymentDate && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default Expense;